import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const AuthGrpcContractProvider: Provider = {
  provide: MainApi.AuthGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.AuthGrpcContractClient, 'mainApi'),
};
